import { graphql } from '@/generated/gql';

export const INTAKE_LIST_NEW_SESSION = graphql(/* GraphQL */ `
  mutation CreateChatSession($data: SvbrgChatSessionCreateInput!) {
    sevenbridges {
      chatSession {
        create(data: $data) {
          id
        }
      }
    }
  }
`);
